export function isUsingNewLayout(locale) {
  const supportedLocales = ['en'];
  return supportedLocales.includes(locale);
}